<ng-container *ngIf="isOpen">
	<!-- SVG mask backdrop (creates a real “hole” so target is NOT dimmed) -->
	<div class="tour__backdrop" (click)="close()">
		<svg class="tour__maskSvg" aria-hidden="true">
      <defs>
        <mask id="tour-cutout-mask">
          <!-- everything visible by default -->
          <rect x="0" y="0" width="100%" height="100%" fill="white"></rect>

          <!-- cutout area becomes transparent (black in mask) -->
          <rect
            [attr.x]="maskX"
            [attr.y]="maskY"
            [attr.width]="maskW"
            [attr.height]="maskH"
            [attr.rx]="maskRx"
            [attr.ry]="maskRx"
            fill="black">
          </rect>
        </mask>
      </defs>

      <!-- the dark overlay uses the mask -->
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        [attr.fill]="'rgba(0,0,0,' + overlayOpacity + ')'"
        mask="url(#tour-cutout-mask)">
      </rect>
    </svg>
	</div>

	<!-- Highlight outline (pure border, does NOT dim content) -->
	<div class="tour__highlight" [style.top.px]="highlight.top" [style.left.px]="highlight.left" [style.width.px]="highlight.width" [style.height.px]="highlight.height">
	</div>

	<!-- Popover -->
	<div class="tour__popover" [style.top.px]="popoverTop" [style.left.px]="popoverLeft" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

		<div class="tour__header">
			<div class="tour__title">{{ step?.title }}</div>
			<button class="tour__iconBtn" type="button" (click)="close()" aria-label="Close">×</button>
		</div>

		<div class="tour__body">
			<div class="tour__text">{{ step?.body }}</div>
		</div>

		<div class="tour__footer">
			<div class="tour__progress">Step {{ index + 1 }} / {{ total }}</div>
			<div class="tour__actions">
				<button class="tour__btn" type="button" (click)="prev()" [disabled]="index === 0">Back</button>
				<button class="tour__btn tour__btn--primary" type="button" (click)="nextOrDone()">
          {{ index + 1 < total ? 'Next' : 'Done' }}
        </button>
			</div>
		</div>
	</div>
</ng-container>
